import { whiteColor } from 'assets/jss/material-dashboard-pro-react';

const loader = (theme) => ({
	'@keyframes rotateSpinner': {
		'100%': {
			transform: 'rotate(360deg)',
		},
	},
	loaderWrapper: {
		position: 'absolute',
		width: '100%',
		height: '100%',
		opacity: '.7',
		zIndex: 1,
		background: whiteColor,
		top: '0',
		[theme.breakpoints.up('sm')]: {
			top: '16px',
		},
		display: 'flex',
		left: '0',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '16px',
	},
	loader: {
		animation: '$rotateSpinner 2s linear infinite',
	},
	loadingText: {
		fontSize: theme.fontSize(16),
		fontFamily: theme.fontFamily.albert.bold,
	},
});

export default loader;
